import { Icon } from "@iconify/react/dist/iconify.js";
import { useAgenda } from "./agendaFunction";
import Modal from "../../../Components/Atoms/Modal";
import Button from "../../../Components/Atoms/Button";
import { Helmet } from "react-helmet";

const AgendaPage = () => {
  const {
    tabSelected,
    handleChangeTab,
    tabs,
    listData,
    handleDetail,
    modalValue,
    setModalValue,
    handleCloseModal,
  } = useAgenda();

  const getColor = (color) => {
    return `bg-[${color}]`;
  };

  const getBorderColor = (color) => {
    return `border-l-[${color}]`;
  };

  return (
    <div className="w-full min-h-screen h-fit  text-black relative flex flex-col items-center mt-[80px] md:mt-[100px]">
      <Modal
        show={modalValue.show}
        setShow={() => {
          setModalValue((modalValue) => ({ ...modalValue, show: false }));
        }}
        width="xl"
        persistent={false}
        btnClose={false}
        title={modalValue.title}
        withHeader={true}
      >
        <div className="p-[20px] text-sm w-full">
          <div className="w-full mb-[30px] border-b border-b-gray-300 pb-[30px]">
            <table className="w-full">
              <tr>
                <td>Agenda</td>
                <td>:</td>
                <td>{modalValue.content?.nama}</td>
              </tr>
              <tr>
                <td>Tanggal</td>
                <td>:</td>
                <td>
                  {modalValue.content?.tanggal_display}{" "}
                  {modalValue.content?.start_time} s.d{" "}
                  {modalValue.content?.end_time}
                </td>
              </tr>
              <tr>
                <td>Lokasi</td>
                <td>:</td>
                <td>{modalValue.content?.lokasi}</td>
              </tr>
            </table>
          </div>
          <div className="mb-[20px] font-bold text-[15px]">Detail Agenda</div>
          <div
            className="content-ckeditor"
            dangerouslySetInnerHTML={{ __html: modalValue.content.description }}
          />
          <Helmet>
            <style type="text/css">
              {`
                            ol {
                                list-style-type:decimal; 
                                margin-left: 15px;
                            }
                        `}
            </style>
          </Helmet>
        </div>
        <div className="border-t border-t-gray-200 p-[20px]">
          <div className="flex flex-row justify-end gap-2">
            <Button
              className="bg-gray-400 text-white"
              onClick={handleCloseModal}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
      <div className="w-full text-center max-w-homeWidth px-[40px] md:px-[100px]">
        <div className="font-bold title md:text-[24px] text-[14px]">
          Agenda Musyawarah Nasional XII APJII Tahun 2024
        </div>
        <div className="text-justify mt-[30px]">
          <div className="flex flex-row gap-3">
            {tabs.data.map((tab, index) => {
              return (
                <button
                  onClick={() => handleChangeTab(tab)}
                  className={`flex flex-col py-[19px] ${tabSelected === tab.tanggal
                    ? tab.classActive + " border-l-8"
                    : tab.classNotActice
                    } px-[25px] rounded-t-lg`}
                  key={index}
                >
                  <div className={``}>{tab.hari}</div>
                  <div className="text-[13p]x">{tab.tanggal}</div>
                </button>
              );
            })}
          </div>
        </div>
        <div className="text-justify mt-[30px]">
          {listData.data.map((post, index) => {
            return (
              <div className="mb-[10px] flex flex-col w-full" key={index}>
                <div
                  className={`border-l-8 ${getBorderColor(
                    post?.color_label ? post?.color_label : "#4bae33"
                  )} rounded-lg flex flex-col px-[30px]  py-[20px] border-y border-y-slate-200 border-r border-r-slate-200`}
                >
                  <div className="flex flex-row gap-4 items-center">
                    <div
                      className={`w-[20px] h-[20px] rounded  ${getColor(
                        post?.color_label ? post?.color_label : "#4bae33"
                      )}`}
                    ></div>
                    <div className="text-[18px] font-bold">{post?.nama}</div>
                  </div>
                  <div className="flex flex-row text-[#616161] mt-[10px] gap-2 items-center">
                    <div>
                      <Icon icon="solar:calendar-outline" />
                    </div>
                    <div>
                      {post?.tanggal} on {post?.start_time} sampai dengan{" "}
                      {post?.end_time} WIB
                    </div>
                  </div>
                  <div className="flex flex-row text-[#616161] mt-[0px] gap-2 items-center justify-between">
                    <div className="flex flex-row text-[#616161] mt-[0px] gap-2 items-center">
                      <div>
                        <Icon icon="mingcute:location-line" />
                      </div>
                      <div>{post?.lokasi}</div>
                    </div>
                    {post?.description && (
                      <button
                        onClick={() => handleDetail(post)}
                        className="bg-[#4bae33] text-white px-5 py-2 rounded"
                      >
                        Detail Acara
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default AgendaPage;
